import * as React from "react";
import { Context } from "./_context";
export const StudentIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.612 3.078a1 1 0 0 1 .897.06l11 6.5.108.075a1 1 0 0 1 0 1.574l-.108.074-11 6.5a1 1 0 0 1-1.018 0L8 15.798V20.5H6v-5.884L.491 11.361a1 1 0 0 1 0-1.722l11-6.5.121-.06ZM2.966 10.5l3.966 2.343 5.513-3.675 1.11 1.664-4.712 3.14L12 15.839l9.033-5.338L12 5.161l-9.034 5.34Z", fill: "currentColor" }));
  return iconset[size];
};
StudentIcon.iconId = "5Cmg27";
